export default {
  LOGIN_TO_ADD_PRODUCT_TO_WISHLIST: "Please login to add products to your wishlist.",
  LOGIN_TO_REMOVE_PRODUCT_FROM_WISHLIST: "Please login to remove products from your wishlist.",
};
